export class NonAnalyticsEvents {
    static readonly priceSpiderPurchase = 'priceSpiderPurchase';
}
